import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../shared/app.config';
import { replaceDynamicParams } from '../../utils/app.generic';
import { catchError, finalize, of, tap } from 'rxjs';
import { initailUserAuthRes, IUserAuthObj, IUserAuthRes } from './state';

@Injectable()
export class ViewManageUserAuthsService {

  readonly items = signal<IUserAuthObj[]>([]);
  readonly loading = signal<boolean>(false);
  readonly errors = signal<string>('');

  constructor(private readonly http: HttpClient, private readonly config: AppConfig) { }

  getUserAuths(req: unknown) {
    this.loading.set(true);
    this.errors.set('');
    return this.http.post<IUserAuthRes>(this.config.urls.getUserAuths, req).pipe(
      tap((data: IUserAuthRes) => {
        if (Array.isArray(data?.userAuthorizations)) {
          this.items.set(data.userAuthorizations);
        }
      }),
      catchError(() => {
        this.errors.set('Failed to load user authorizations.');
        this.loading.set(false);
        return of(initailUserAuthRes);
      }),
      finalize(() => this.loading.set(false))
    );
  }

  updateAuths(role: string, req: unknown) {
    const url = replaceDynamicParams(this.config.urls.manageAuths, {role});
    this.loading.set(true);
    this.errors.set('');
    return this.http.post<unknown>(url, req).pipe(
      catchError(() => {
        this.errors.set('Failed to update authorizations.');
        this.loading.set(false);
        return of(null);
      }),
      finalize(() => this.loading.set(false))
    );
  }
}
